import type {
  ReportFormData,
  TextAreaField as TextAreaFieldType,
} from '@/screens/ReportCreation/reportCreation.types';
import { FieldValues, useController } from 'react-hook-form';
import { YStack } from 'tamagui';
import { FieldError } from '../FieldError';
import type { ControlledFieldController } from '../formController.types';
import { TextAreaField } from './TextAreaField';

interface ControlledTextAreaFieldProps<FormValues extends FieldValues> {
  field: TextAreaFieldType;
  formController: ControlledFieldController<FormValues>;
}

export const ControlledTextAreaField = <
  FormValues extends FieldValues = ReportFormData,
>({
  field,
  formController,
}: ControlledTextAreaFieldProps<FormValues>): React.ReactElement => {
  const { field: controllerField, fieldState } = useController<FormValues>({
    ...formController,
  });

  const value =
    typeof controllerField.value === 'string' ? controllerField.value : '';

  return (
    <YStack gap="$1">
      <TextAreaField
        label={field.label}
        placeholder={field.placeholder}
        value={value}
        onValueChange={controllerField.onChange}
        maxLength={field.maxLength}
        required={field.required}
      />
      <FieldError message={fieldState.error?.message} />
    </YStack>
  );
};
